import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom";
import Slider from "react-slick";

import "../../../../node_modules/slick-carousel/slick/slick.css";
import "../../../../node_modules/slick-carousel/slick/slick-theme.css";
import "./TimePickerStyle.scss";

const clocks = Array.from({length: 24}, (_, i) => i);
const initHours = () => {
    let times = [];
    // for (let i = 0; i < clocks.length; i++) {
    //     times.push({id: index,hour: (h < 10) ? `0${h}` : h, min: "00"});
    //
    // }

    clocks.map((h, index) => {
        times.push({id: index, hour: (h < 10) ? `0${h}` : h, min: "00"});
        times.push({id: (index + 0.5), hour: (h < 10) ? `0${h}` : h, min: "30"});
    })
    return times;
};

const SimpleSlider = ({
                          title,
                          setActive = 0,
                          containerClassName,
                          onChange
                      }) => {
    const hours = initHours();
    // const [setting, setSetting] = useState();


   const settings = {
            className: "center",
            centerMode: true,
            infinite: true,
            slidesToShow: 1,
            speed: 100,
            slidesToScroll: 3,
            vertical: true,
            verticalSwiping: true,
            // variableWidth: true,
            variableHeight: true,
            swipeToSlide: true,
            arrows: false,
            adaptiveHeight: false,
            afterChange: (e) => {
                onChange(hours[e].hour + ":" + hours[e].min)
            },
            // beforeChange: (current, next) => this.setState({ slideIndex: next })
        };


    return (
        <div className={`time-picker-main d-flex flex-column justify-content-center ${containerClassName}`}>
            <span className="txt-t2-m m-auto" style={{paddingBottom: "12px"}}>{title}</span>
            <div className="main">
                <Slider
                    {...settings}
                    className="slider-entity"
                    // ref={(slider) => (this.slider1 = slider)}
                >
                    {hours.map((hour) => (
                        <div key={hour.id} className="d-flex justify-content-center">
                            <span className="my-auto">{hour.hour}</span>
                            <span className="my-auto" style={{paddingLeft: "10px", paddingRight: "10px"}}>:</span>
                            <span className="my-auto">{hour.min}</span>
                        </div>
                    ))}
                </Slider>
                <div className="mask">
                    <div className="mask-item"/>
                </div>
            </div>
        </div>

    )
}

export default SimpleSlider
